import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-toolbar-panel',
  imports: [],
  templateUrl: './toolbar-panel.component.html',
  styleUrl: './toolbar-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarPanelComponent {

}
